module.exports = __webpack_public_path__ + "static/media/David.323033c2.jpg";